import React from 'react';
// Data
import { linkButtonArray } from '../../utils/data/LinksData';
// Images
import BabyImage from '../../assets/images/main/mistress-maria-professional-dominatrix-and-fem-dom-training-baby-sissy.webp';
import EliteMistress from '../../assets/images/banners/1eliteukmistresses.gif';
import DominaSuperior from '../../assets/images/banners/dominasuperior.gif';
import UKMistress from '../../assets/images/banners/uk-mistress-directory.webp';
import MistressZone from '../../assets/images/banners/UK-Mistress-Zone-Banner.gif';
import MistressGuide from '../../assets/images/banners/Worldwide-Mistress-Guide-2018.gif';
// Constants
import {
  DOMINA_SUPERIOR,
  ELITE_MISTRESS_UK,
  UK_MISTRESS_DIRECTORY,
  UK_MISTRESS_ZONE,
  WORLDWIDE_GUIDE,
} from '../../utils/Constants';

function LinksPageMainContainer() {
  return (
    <main role='main' className='grid pt-6'>
      <article className='text-center px-6 sm:py-4 lg:py-8'>
        <h3 className='text-2xl lg:text-4xl'>Spoil & Treat Me!</h3>
        <p className='max-w-2xl mx-auto text-lg mt-4'>
          Your devotion doesn’t go unnoticed. Show your admiration with
          tributes, gifts, and attention. The more you give, the closer you
          crawl.
        </p>
        <p className='max-w-2xl mx-auto text-lg mt-2'>
          Follow Me across my platforms to stay updated with new content, live
          sessions, and exclusive offers. Whether you're a loyal pet or a
          curious voyeur—there’s something for you to obey, adore, and indulge
          in.
        </p>
        <p className='max-w-2xl mx-auto text-lg mt-2 italic'>
          Don’t lurk in silence. Submit your tribute. Click, follow, and serve.
        </p>
      </article>
      <section className='grid justify-center mx-auto py-8 px-4 gap-y-4 w-fit'>
        {linkButtonArray.map((btn, index) => (
          <a
            key={index}
            href={btn.link}
            className={`flex items-center gap-3 cursor-pointer bg-colour1 border-2 border-solid border-colour5 hover:bg-colour2 neon_button px-6 py-2 w-full text-center text-colour5 hover:text-colour5 ${
              !btn.link ? 'hidden' : ''
            }`}
            aria-label={`Visit ${btn.text}`}
            target='_blank'
            rel='noopener noreferrer'
          >
            <span className='text-2xl'>{btn.icon}</span>
            <div className='text-center w-full'>
              <span>{btn.text}</span>
            </div>
          </a>
        ))}
      </section>

      {/* Image */}
      <section className='grid lg:hidden'>
        <img
          src={BabyImage}
          alt='Mistress Maria dressed as a nurturing adult baby nanny training a sissy'
          loading='lazy'
          width={600}
          height={800}
          className='shadow-lg'
        />
      </section>

      {/* Banners */}
      <section className='grid justify-center mx-auto py-8 px-4 gap-6 w-fit'>
        <h4 className='text-xl lg:text-2xl text-center font-semibold'>
          Find Me On
        </h4>

        <div className='grid grid-cols-1 sm:grid-cols-2 gap-6 justify-items-center'>
          <a href={ELITE_MISTRESS_UK} target='_blank' rel='noopener noreferrer'>
            <img
              src={EliteMistress}
              alt='Elite UK Mistresses Directory'
              className='shadow-md hover:opacity-80 transition'
            />
          </a>
          <a href={DOMINA_SUPERIOR} target='_blank' rel='noopener noreferrer'>
            <img
              src={DominaSuperior}
              alt='Domina Superior'
              className='shadow-md hover:opacity-80 transition'
            />
          </a>
          <a
            href={UK_MISTRESS_DIRECTORY}
            target='_blank'
            rel='noopener noreferrer'
          >
            <img
              src={UKMistress}
              alt='UK Mistress Directory'
              className='shadow-md hover:opacity-80 transition'
            />
          </a>
          <a href={UK_MISTRESS_ZONE} target='_blank' rel='noopener noreferrer'>
            <img
              src={MistressZone}
              alt='UK Mistress Zone'
              className='shadow-md hover:opacity-80 transition'
            />
          </a>
          <a href={WORLDWIDE_GUIDE} target='_blank' rel='noopener noreferrer'>
            <img
              src={MistressGuide}
              alt='Worldwide Mistress Guide'
              className='shadow-md hover:opacity-80 transition'
            />
          </a>
          <a
            href='http://ukmistressguide.co.uk'
            target='_blank'
            rel='noopener noreferrer'
          >
            <img
              src='http://ukmistressguide.co.uk/banners/ukMistressGuideflashbanner.gif'
              alt='UK Mistress Guide Flash Banner'
              width={468}
              height={60}
              className='border border-solid border-gray-300 shadow-md hover:opacity-80 transition'
            />
          </a>
        </div>
      </section>
    </main>
  );
}

export default LinksPageMainContainer;
